<template>
  <div>
    <!-- 面包屑 start -->
    <div class="breadMarginTop">
      <!-- <Bread :breadChild=toBreadChild></Bread> -->
    </div>

    <!-- 面包屑 end -->
    <div class="contentCox" >
      <div class="contentLeft"  @click="toPage('SuccessCases/CaseDetailWanDa')">
        <img :src="contentLeftImg1" alt class="oneImgCss">
        <div class="positionLeft">
          <div class="positionRightText">万达电影</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop1" class="positionTop1" alt>
          <!-- <div class="textP">老牌网红餐厅的1到2智慧升级</div> -->
          <div class="textP">传统影厅到数字化智能影厅的进阶</div>
        </div>
      </div>
      <div class="contentRight" @click="toPage('SuccessCases/CaseTaihe')">
        <img :src="contentRightImg1" alt class="oneImgCss">
        <div class="positionRight" >
          <div class="positionRightText">泰禾影城</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask maskRight" @mouseout="toHiddleMask2"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop2" class="positionTop2" alt>
          <div class="textP">
            <div>传统影厅到数字化影厅的进阶</div>
          </div>
        </div>
      </div>
      <!-- <div class="contentLeft">
        <img :src="contentLeftImg2" alt class="oneImgCss">
        <div class="positionLeft">
          <div class="positionRightText">adidas</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop3" class="positionTop1" alt>
          <div class="textP">
            <div>从不可触及转向随意生活，以成套布</div>
            <div>局生活消费，定义未来观影体验</div>
          </div>
        </div>
      </div>
      <div class="contentRight">
        <img :src="contentRightImg2" alt class="oneImgCss">
        <div class="positionRight">
          <div class="positionRightText">可口可乐</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask maskRight"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop4" class="positionTop2" alt>
          <div class="textP">
            <div>从不可触及转向随意生活，以成套布</div>
            <div>局生活消费，定义未来观影体验</div>
          </div>
        </div>
      </div> -->
      <div class="contentLeft" @click="toPage('SuccessCases/SuccessCaseDetail')">
        <img :src="contentLeftImg3" alt class="oneImgCss">
        <div class="positionLeft">
          <div class="positionRightText">海底捞</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop5" class="positionTop1" alt>
          <div class="textP">老牌网红餐厅的1到2智慧升级</div>
          <!-- <div class="textP">引领新的餐饮社交文化。</div> -->
        </div>
      </div>

      <div class="contentRight bgCss" @click="toPage('SuccessCases/CaseCosta')">
        <img :src="contentRightImg3" alt class="oneImgCss">
        <div class="positionRight">
          <div class="positionRightText">costa</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask maskRight"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop6" class="positionTop2" alt>
          <div class="textP">咖啡连锁品牌的智慧餐牌升级</div>
          <!-- <div class="textP">引领新的餐饮社交文化。</div> -->
        </div>
      </div>
      <div class="contentLeft"   @click="toPage('SuccessCases/teBuCase')">
        <img :src="contentLeftImg4" alt class="oneImgCss">
        <div class="positionLeft">
          <div class="positionRightText">特步</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop7" class="positionTop1" alt>
          <div class="textP">国产运动品牌智慧门店新范式</div>
          <!-- <div class="textP">引领新的餐饮社交文化。</div> -->
        </div>
      </div>

      <div class="contentRight bgCss"  @click="toPage('SuccessCases/CaseNorthFace')">
        <img :src="contentLeftImg5" alt class="oneImgCss">
        <div class="positionRight">
          <div class="positionRightText" style="font-size:2.3rem;">The North Face</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask maskRight"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop8" class="positionTop2" alt>
          <div class="textP">户外品牌的新零售探索</div>
        </div>
      </div>
    </div>
    <!-- start -->
    <div class="contentCox">
      <div class="contentLeft"  @click="toPage('SuccessCases/CasePiglet')">
        <img :src="contentLeftImg7" alt class="oneImgCss">
        <div class="positionLeft">
          <div class="positionRightText">小猪班纳</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop9" class="positionTop1" alt>
          <div class="textP">高端童装的智慧门店改造</div>
          <!-- <div class="textP">引领新的餐饮社交文化。</div> -->
        </div>
      </div>

      <div class="contentRight bgCss" @click="toPage('SuccessCases/CaseHotwind')">
        <img :src="contentRightImg5" alt class="oneImgCss">
        <div class="positionRight">
          <div class="positionRightText">热风</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask maskRight"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop10" class="positionTop2" alt>
          <div class="textP">连锁快销的新零售需求升级</div>
          <!-- <div class="textP">引领新的餐饮社交文化。</div> -->
        </div>
      </div>
      <div class="contentLeft" @click="toPage('SuccessCases/CaseFellowChicken')">
        <img :src="contentLeftImg6" alt class="oneImgCss">
        <div class="positionLeft">
          <div class="positionRightText">老乡鸡</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop11" class="positionTop1" alt>
          <div class="textP">中式快餐的餐牌数字化改造</div>
          <!-- <div class="textP">引领新的餐饮社交文化。</div> -->
        </div>
      </div>

      <div class="contentRight bgCss"   @click="toPage('SuccessCases/CaseGXG')">
        <img :src="contentRightImg6" alt class="oneImgCss">
        <div class="positionRight">
          <div class="positionRightText">GXG</div>
          <img :src="positionTopLine" alt class="positionLineCss">
        </div>

        <div class="mask maskRight"></div>
        <div class="positionText oneBoxPosition">
          <img :src="positionTop12" class="positionTop2" alt>
          <div class="textP">场景化新零售旅程</div>
          <!-- <div class="textP">引领新的餐饮社交文化。</div> -->
        </div>
      </div>
    </div>
 
    <!-- end -->
  </div>
</template>
<script>
import bgImg from "@/assets/images/successAnLi.png";
import contentLeftImg1 from "@/assets/images/contentLeftImg1.png";
import contentRightImg1 from "@/assets/images/contentRightImg1.png";
import contentLeftImg2 from "@/assets/images/contentLeftImg2.png";
import contentRightImg2 from "@/assets/images/contentRightImg2.png";
import contentLeftImg3 from "@/assets/images/contentLeftImg3.png";
import contentLeftImg4 from "@/assets/images/contentLeftImg4.png";
import contentLeftImg5 from "@/assets/images/contentLeftImg5.png";
import contentLeftImg6 from "@/assets/images/contentLeftImg6.png";
import contentLeftImg7 from "@/assets/images/contentLeftImg7.png";
import contentRightImg3 from "@/assets/images/contentRightImg3.png";
import contentRightImg4 from "@/assets/images/contentRightImg4.png";
import contentRightImg5 from "@/assets/images/contentRightImg5.png";
import contentRightImg6 from "@/assets/images/contentRightImg6.png";

import positionTop1 from "@/assets/images/positionTop1.png";
import positionTop2 from "@/assets/images/positionTop2.png";
import positionTop3 from "@/assets/images/positionTop3.png";
import positionTop4 from "@/assets/images/positionTop4.png";
import positionTop5 from "@/assets/images/positionTop5.png";
import positionTop6 from "@/assets/images/positionTop6.png";
import positionTop7 from "@/assets/images/positionTop7.png";
import positionTop8 from "@/assets/images/positionTop8.png";
import positionTop9 from "@/assets/images/positionTop9.png";
import positionTop10 from "@/assets/images/positionTop10.png";
import positionTop11 from "@/assets/images/positionTop11.png";
import positionTop12 from "@/assets/images/positionTop12.png";
import positionTopLine from "@/assets/images/positionTopLine.png";

import anLiIconHoverDe from "@/assets/images/anLiIconHover1.png";
import Bread from "@/components/bread.vue";
import { constants } from "os";

export default {
  name: "SuccessCases",
  components: {
    Bread
  },
  data() {
    return {
      toBreadChild: ["案例"],
      classCur: 0,
      filterIndex: 0,
      anLiIconHoverDe: anLiIconHoverDe,
      mask1Bol: false,
      mask2Bol: false,
      mask3Bol: false,
      mask4Bol: false,
      mask5Bol: false,
      mask6Bol: false,
      mask7Bol: false,
      bgImg: bgImg,
      contentRightImg1: contentRightImg1,
      contentLeftImg1: contentLeftImg1,
      contentLeftImg2: contentLeftImg2,
      contentRightImg2: contentRightImg2,
      contentLeftImg3: contentLeftImg3,
      contentLeftImg4: contentLeftImg4,
      contentLeftImg5: contentLeftImg5,
      contentLeftImg6: contentLeftImg6,
      contentLeftImg7: contentLeftImg7,
      contentRightImg3: contentRightImg3,
      contentRightImg4: contentRightImg4,
      contentRightImg5: contentRightImg5,
      contentRightImg6: contentRightImg6,

      positionTop1: positionTop1,
      positionTop2: positionTop2,
      positionTop3: positionTop3,
      positionTop4: positionTop4,
      positionTop5: positionTop5,
      positionTop6: positionTop6,
      positionTop7: positionTop7,
      positionTop8: positionTop8,
      positionTop9: positionTop9,
      positionTop10: positionTop10,
      positionTop11: positionTop11,
      positionTop12: positionTop12,
      positionTopLine: positionTopLine,
      textArray: ["新餐饮", "新零售", "智慧门店", "智慧展厅", "新院线"],
      listImg: [
        {
          url: require("@/assets/images/anLiIcon1.png"),
          text: "全部案例"
        },
        {
          url: require("@/assets/images/anLiIcon2.png"),
          text: "新零售"
        },
        {
          url: require("@/assets/images/anLiIcon3.png"),
          text: "智慧门店"
        },
        {
          url: require("@/assets/images/anLiIcon4.png"),
          text: "新餐饮"
        },
        {
          url: require("@/assets/images/anLiIcon5.png"),
          text: "新院线"
        }
      ],

      listImg1: [
        {
          url: require("@/assets/images/anLiIconHover1.png"),
          text: "全部案例"
        },
        {
          url: require("@/assets/images/anLiIconHover2.png"),
          text: "新零售"
        },
        {
          url: require("@/assets/images/anLiIconHover3.png"),
          text: "智慧门店"
        },
        {
          url: require("@/assets/images/anLiIconHover4.png"),
          text: "新餐饮"
        },
        {
          url: require("@/assets/images/anLiIconHover5.png"),
          text: "新院线"
        }
      ]
    };
  },
  mounted() {
    this.changeActive(0)
  },
  methods: {
    changeActive(index) {
      this.listImg[index] = this.listImg1[index];
      this.listImg.splice(index, 1, this.listImg1[index]);
      this.classCur = index;
    },
    removeActive(index) {
      this.listImg = [
        {
          url: require("@/assets/images/anLiIcon1.png"),
          text: "全部案例"
        },
        {
          url: require("@/assets/images/anLiIcon2.png"),
          text: "新零售"
        },
        {
          url: require("@/assets/images/anLiIcon3.png"),
          text: "智慧门店"
        },
        {
          url: require("@/assets/images/anLiIcon4.png"),
          text: "新餐饮"
        },
        {
          url: require("@/assets/images/anLiIcon5.png"),
          text: "新院线"
        }
      ];
      this.filterIndex = index
      console.log('filterIndex', this.filterIndex)
      this.changeActive(index)
    },
    toPage(val) {
      // this.$router.push(val);
      let routeUrl = this.$router.resolve({
        path: `${val}`
      });
      window.open(routeUrl.href, "_blank");
    },
    toDetailPage(index) {
     
    },
    toShowMask1() {
      this.mask1Bol = true;
      console.log(this.mask1Bol);
      console.log(123);
    },
    toHiddleMask1() {
      this.mask1Bol = false;
      console.log(456);
    },
    toShowMask2() {
      this.mask2Bol = true;
    },
    toHiddleMask2() {
      this.mask2Bol = false;
    },
    toShowMask3() {
      this.mask3Bol = true;
    },
    toHiddleMask3() {
      this.mask3Bol = false;
    },
    toShowMask4() {
      this.mask4Bol = true;
    },
    toHiddleMask4() {
      this.mask4Bol = false;
    },
    toShowMask5() {
      this.mask5Bol = true;
    },
    toHiddleMask5() {
      this.mask5Bol = false;
    },
    toShowMask6() {
      this.mask6Bol = true;
    },
    toHiddleMask6() {
      this.mask6Bol = false;
    },
    toShowMask7() {
      this.mask7Bol = true;
    },
    toHiddleMask7() {
      this.mask7Bol = false;
    }
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 660px;
  height: 143px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 20px;
}

.contentBottom {
  width: 660px;
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* imgListBox start */
.imgListBox {
  display: flex;
  width: 74%;
  max-width: 1200px;
  margin: auto;
  flex-wrap: wrap;
  margin-top: 39px;
  padding: 30px 0;
  position: absolute;
  bottom: -125px;
  left: calc(50% - 37%);
  background: #fff;
  box-shadow: 0px 3px 27px 0px rgba(0, 0, 0, 0.1);
}

.imgBox {
  flex-grow: 1;
  margin-top: 20px;
  font-size: 2.4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 34px;
  text-align: center;
  border-right: 1px solid rgba(236, 235, 235, 1);
  padding: 10px 0;
}

.imgBox img {
}

.imgBoxTwo {
  border-right: 0px;
}
.hoverText {
  /* transition: 0.5s; */
}
.imgBox:hover .hoverText {
  /* color: rgba(252, 200, 0, 1); */
}

/* imgListBox end */
.contentCox::after {
  content: "";
  display: block;
  clear: both;
}

.contentCox {
  width: 70%;
  max-width: 1100px;
  margin: auto;
  /* margin-top: 30px; */
}

.oneImgCss {
  width: 98%;
  /* max-width: 578px; */
}

.contentCox img:first-child {
}

.contentLeft {
  width: 50%;
  float: left;
  margin-bottom: 16px;
  /* opacity:0.8; */
  /* background:rgba(0,0,0,1); */
}

.contentRight {
  width: 50%;
  float: left;
  text-align: right;
  margin-bottom: 16px;
}

.contentRight,
.contentLeft {
  position: relative;
  font-size: 0;
}

.textBoxCss {
  width: 194px;
  height: 32px;
  font-size: 3.2rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
}

.positionText {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 10;
}

.mask {
  width: 98%;
  /* max-width: 578px; */
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 5;
  transition: 0.5s;
}

.maskRight {
  right: 0;
}

.oneBoxPosition {
  width: 80%;
  height: 33%;
  text-align: center;
}
.oneBoxPosition img{
  width: 70%;
  max-width: 300px;
}
.textP {
  position: absolute;
  bottom: -30px;
  width: 100%;
  font-size: 1.9rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  opacity: 0;
}

.positionTop1 {
  /* margin-bottom: 29px; */
  opacity: 0;
}

.positionRight {
  position: absolute;
  width: 39%;
  height: 40px;
  right: -5px;
  bottom: 46px;
  text-align: left;
  z-index: 10;
  opacity: 1;
}
.positionRight img{
  width: 100%;
}
.positionLeft {
  position: absolute;
  width: 39%;
  height: 40px;
  left: -5px;
  bottom: 46px;
  text-align: right;
  z-index: 10;
}
.positionLeft img{
  width: 100%;
}

.positionRightText {
  font-size: 3.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}
.positionLeft {
  opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.breadMarginTop {
  margin-top: 170px;
}
.contentLeft:hover .mask {
  opacity: 0.8;
}
.contentLeft:hover .textP {
  opacity: 1;
}
.contentLeft:hover .positionTop1 {
  opacity: 1;
}
.contentLeft:hover .positionLeft {
  opacity: 0;
}
/* right hover */
.contentRight:hover .positionRight {
  opacity: 0;
}
.contentRight:hover .positionRight {
  opacity: 0;
}
.contentRight:hover .textP {
  opacity: 1;
}
.contentRight:hover .mask {
  opacity: 0.8;
}
.positionTop2 {
  opacity: 0;
}

.contentRight:hover .positionTop2 {
  opacity: 1;
}
.ClassActive{
  color:rgba(252, 200, 0, 1)
}
</style>



// WEBPACK FOOTER //
// src/view/caseSearch/allCase.vue